import React from 'react';
import CPageModule from '../../../components/CPageModule';
import CPageModulePlot from '../../../components/CPageModulePlot';
import CPandasTable from '../../../components/CPandasTable';
import {type PlotlyResponse} from '../../../models/PlotlyModel';
import {type TPandasTable} from '../../../models/TPandasTable';
import CStatefulContainer from '../../../components/CStatefulContainer';
import CHorizontalScrollContainer from '../../../components/CHorizontalScrollContainer';
import CLocalizedText from '../../../components/CLocalizedText';
import {type IResponse} from '../../../models/IResponse';

interface Props {
  plot?: IResponse<PlotlyResponse>
  table?: IResponse<TPandasTable>
}

export default function CSectorTotalReturn(props: Props) {
  return (
      <CPageModule fullWidth submodule>
        <CPageModule submodule>
          <h3>
            <CLocalizedText dictKey={'sectorPerformance.cSectorTotalReturn.heading'}/>
          </h3>
          <p>
            <CLocalizedText dictKey={'sectorPerformance.cSectorTotalReturn.desc'}/>
          </p>
        </CPageModule>
        <CStatefulContainer submodule apiRequestState={props.plot?.state} showContent={!!props.plot?.data}>
          <CPageModulePlot data={props.plot?.data?.data} layout={props.plot?.data?.layout}/>
        </CStatefulContainer>
        {!!props.plot?.data && (
            <CStatefulContainer submodule apiRequestState={props.table?.state} showContent={!!props.table?.data}>
              <CHorizontalScrollContainer>
                <CPandasTable
                  data={props.table?.data}
                  colSpanArr={[1.5, ...Array(Math.max(0, Object.keys(props.table?.data ?? {}).length - 1)).fill(1)]}
                  colAlignmentArr={['left', ...Array(Math.max(0, Object.keys(props.table?.data ?? {}).length - 1)).fill('right')]}/>
              </CHorizontalScrollContainer>
            </CStatefulContainer>
        )}
      </CPageModule>
  );
}